export const apiField = 's5_roof_manufacturer';

const makeOptions = data => data.map(item => typeof item === 'object' ? item : ({ value: item, name: item }));


function makeConfig(data) {
  return{
    label: 's5RoofManufacturer',
    type: 'Select',
    apiField,
    missing: undefined,
    tooltip: undefined,
    data: makeOptions(data)
}};



export default function s5manufacturer(data){ 
      return makeConfig(data);
    }